module.exports = __webpack_public_path__ + "img/icon07.b932ef59.png";